export default "/fonts/Flaticon.woff?a53eae6b65c8492060d77a4b55fb79f7";